import React from 'react';
import { Scrollbars } from 'react-custom-scrollbars';

import './styles.css';

export default props => {
  return (
    <Scrollbars
      renderTrackVertical={props => (
        <div {...props} className='scroll-track-vertical' />
      )}
      renderThumbVertical={props => <div {...props} className='scroll-thumb' />}
      renderTrackHorizontal={props => (
        <div {...props} className='scroll-track-horizontal' />
      )}
      renderThumbHorizontal={props => (
        <div {...props} className='scroll-thumb' />
      )}
      ref={props.innerRef}
      {...props}
      hideTracksWhenNotNeeded={true}
    ></Scrollbars>
  );
};
